export default function AreaSection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12 text-center">
          対応エリア
        </h2>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div className="h-[500px] rounded-3xl overflow-hidden shadow-lg">
            <img
              src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/6e08cbed6eff271e0ffe64115f3505dc.png"
              alt="対応エリアマップ"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-8">
            <div className="bg-cyan-50 rounded-3xl p-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-map-pin-line text-cyan-600 text-3xl"></i>
                対応地域
              </h3>
              <ul className="space-y-4 text-lg">
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-cyan-600"></i>
                  <span className="font-bold">神奈川県逗子市</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-cyan-600"></i>
                  <span className="font-bold">神奈川県三浦郡葉山町</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-3xl p-10">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                その他の地域について
              </h3>
              <p className="text-gray-700 leading-relaxed">
                上記以外の地域につきましては、一度ご相談ください。状況に応じて対応できる場合がございます。お気軽にお問い合わせください。
              </p>
            </div>

            <div className="bg-amber-50 rounded-3xl p-10">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-information-line text-amber-600"></i>
                ご注意
              </h3>
              <p className="text-gray-700 leading-relaxed">
                サービス提供には介護保険の要介護認定が必要です。認定を受けていない方は、まずお住まいの市町村の介護保険担当窓口にご相談ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
